import { getCatalogueImage } from './imageHelpers';
import { Article, Taxonomy } from '../types';

type PArticle = Pick<Article, 'image'> & {
  taxonomy: Pick<Taxonomy, 'image'>;
};

interface ArticleImageProps extends React.HTMLAttributes<HTMLImageElement> {
  article: PArticle;
  env: any;
}

const ArticleImage = (props: ArticleImageProps) => {
  const { article, env, ...rest } = props;

  const image = getCatalogueImage(env, article.image, article.taxonomy.image);

  return <img src={image} {...rest} />;
};

export default ArticleImage;
